export const categoryMenuCreateNewAriaLabel = "Vic";
export const categoryMenuCreateNewText = "Wic";
export default {categoryMenuCreateNewAriaLabel,categoryMenuCreateNewText};